import { Box as MantineBox, BoxProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedBoxProps extends BoxProps {
  centered?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
}

const Box = forwardRef<HTMLDivElement, ThemedBoxProps>(
  ({ centered = false, fullWidth = false, fullHeight = false, style, children, ...rest }, ref) => {
    return (
      <MantineBox
        ref={ref}
        style={{
          display: centered ? 'flex' : undefined,
          justifyContent: centered ? 'center' : undefined,
          alignItems: centered ? 'center' : undefined,
          width: fullWidth ? '100%' : undefined,
          height: fullHeight ? '100%' : undefined,
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineBox>
    );
  }
);

Box.displayName = 'Box';

export default Box;
